import { IReferralItem } from '../../../repositories/cpd/entities/v1_get_referrals_listing/ReferralItem';
import { createSlice } from '@reduxjs/toolkit';
import { getReferralListing } from '../../../thunks/referrer';

const initialState: IReferralItem[] = [];

const referralsSlice = createSlice({
  name: 'referrals',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getReferralListing.fulfilled, (_, action) => action.payload)
      .addCase(getReferralListing.rejected, () => []);
  },
});

export const { reducer: referralsReducer } = referralsSlice;
